var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewRegistration = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8533"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Component 33 \\u2013 2"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 1604",
  fill: "#fff",
  d: "M0 0h100v100H0z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Online registration - Free miscellaneous icons-2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8531"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9321",
  d: "M48.387 70.968h-12.9a3.229 3.229 0 0 0-3.229 3.226 6.458 6.458 0 0 0 6.452 6.452h6.448a6.458 6.458 0 0 0 6.452-6.452 3.229 3.229 0 0 0-3.223-3.226Zm-3.229 6.452H38.71a3.229 3.229 0 0 1-3.226-3.226h12.9a3.229 3.229 0 0 1-3.226 3.226Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 90",
  cx: 1.625,
  cy: 1.548,
  rx: 1.625,
  ry: 1.548,
  transform: "translate(64.549 6.507)"
}), /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 91",
  cx: 1.625,
  cy: 1.548,
  rx: 1.625,
  ry: 1.548,
  transform: "translate(58.048 6.507)"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9322",
  d: "M35.484 6.452h12.9v3.226h-12.9Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9323",
  d: "m93.7 29.548 4.158-4.158a7.316 7.316 0 0 0-10.347-10.345l-7.534 7.535h-5c-.263 0-.523.021-.782.039V8.065A8.074 8.074 0 0 0 66.129 0H17.742a8.074 8.074 0 0 0-8.065 8.065v38.041L5.226 50.56A17.714 17.714 0 0 0 0 63.173 18.073 18.073 0 0 0 .242 66.1l2.51 15.052a29.49 29.49 0 0 0 1.711 6.116l1.989 4.974V100h22.58v-7.753l1.113-2.782c.311-.779.576-1.571.819-2.368h35.165a8.074 8.074 0 0 0 8.065-8.065V49.055l.653-.653 1.481.889a16.285 16.285 0 0 0 13.54 1.484l7.168-2.387H100v-16.13h-2.689Zm-3.908-12.222a4.09 4.09 0 1 1 5.784 5.784l-15.05 15.051-3.856-3.085a12.8 12.8 0 0 0-2.89-1.735Zm-13.04 8.481-6.558 6.558a12.875 12.875 0 0 0-1.558-.106 5.722 5.722 0 0 0-5.537 7.2l-2.018 2.018a2.93 2.93 0 0 1-.539-4.579l8.732-8.732a8.009 8.009 0 0 1 5.7-2.361ZM12.9 8.065a4.845 4.845 0 0 1 4.839-4.839h48.39a4.845 4.845 0 0 1 4.839 4.839v15.256a11.176 11.176 0 0 0-3.226 1.885v-9.077a3.229 3.229 0 0 0-3.226-3.229H19.355a3.229 3.229 0 0 0-3.226 3.226v48.39A3.223 3.223 0 0 0 18 67.431a47.157 47.157 0 0 1-2.482 6 1.377 1.377 0 0 1-2.61-.615Zm12.9 88.71H9.677v-3.227h16.129Zm1.344-8.506-.823 2.055H9.156l-1.7-4.248a26.393 26.393 0 0 1-1.524-5.447L3.423 65.576a15.018 15.018 0 0 1-.2-2.4A14.513 14.513 0 0 1 7.506 52.84l2.171-2.173v22.148a4.6 4.6 0 0 0 8.721 2.06 50.61 50.61 0 0 0 3.823-10.332l1.21-4.835a2.167 2.167 0 0 1 4.263.36l1.263 16.406q.075 1.006.076 2.019a26.231 26.231 0 0 1-1.882 9.776Zm-1.612-33.43a5.387 5.387 0 0 0-5.232 4.085l-.945 3.776V16.129h45.161v12.236l-6.255 6.255a6.146 6.146 0 0 0 .511 9.166l-3.7 3.7-3.155 7.885a4.319 4.319 0 0 0 5.613 5.615l6.982-2.794v6.327H31.271l-.361-4.7a5.418 5.418 0 0 0-5.377-4.981Zm31.508-3.583 4.6 4.6-5.308 2.124a1.113 1.113 0 0 1-1.5-1.013 1.067 1.067 0 0 1 .079-.406Zm13.928 27.776a4.845 4.845 0 0 1-4.839 4.839H31.756a29.485 29.485 0 0 0 .5-5.379q0-1.135-.087-2.266l-.652-8.484h33a3.229 3.229 0 0 0 3.226-3.226v-9.01l3.226-3.226Zm-6.452-24.861-5.784-5.784 6.115-6.113a5.586 5.586 0 0 0 .84.632L72 46.692Zm32.258-9.01h-.261l-7.665 2.555a13.174 13.174 0 0 1-10.86-1.192l-10.64-6.384a2.506 2.506 0 0 1 1.287-4.656 9.66 9.66 0 0 1 6.018 2.116l5.426 4.339h8.631V38.71h-4.171l6.861-6.857 4.842 3.631h.537Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9324",
  d: "M61.291 19.355h-38.71v9.677h38.71Zm-3.226 6.452H25.807v-3.226h32.258Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9325",
  d: "M32.258 32.258h20.968v3.226H32.258Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9326",
  d: "M50 38.71h3.226v3.226H50Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9327",
  d: "M32.258 38.71h14.516v3.226H32.258Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9328",
  d: "M32.258 45.161h20.968v3.226H32.258Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9329",
  d: "M32.258 51.613H50v3.226H32.258Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 9330",
  d: "M32.258 58.065H50v3.226H32.258Z"
}))))));
export default SvgNewRegistration;